<template>
    <router-view />
</template>

<script>
import User from "@2kog/pkg-common/utils/user";
import { mapMutations } from "vuex";
import { getStaticConfig } from "@/service/system";
export default {
    name: "App",
    props: [],
    components: {},
    data: function () {
        return {};
    },
    watch: {
        $route: {
            immediate: true,
            handler(to) {
                // 处理 app 参数
                if (to.query.app) {
                    const app = to.query.app;
                    sessionStorage.setItem("app", app);
                    this.setApp(app);
                }
            },
        },
    },
    methods: {
        ...mapMutations({
            setApp: "SET_APP",
            setLang: "SET_LOCALE",
        }),
        checkTokenVersion() {
            const tokenVersion = localStorage.getItem("token_version");
            getStaticConfig().then((config) => {
                if (config.token_version && config.token_version !== tokenVersion) {
                    User.logout();
                    localStorage.setItem("token_version", config.token_version);
                    // ✅ 保留当前路由的查询参数（首屏导航时 $route.query 可能为空，退回用 URLSearchParams 兜底）
                    const routeQuery = this.$route?.query || {};
                    let query = routeQuery;
                    if (!Object.keys(routeQuery).length && window.location.search) {
                        query = Object.fromEntries(new URLSearchParams(window.location.search).entries());
                    }
                    this.$router.replace({
                        name: "account-login",
                        query,
                    });
                }
            });
        },
    },
    created: function () {
        // 生成特征码
        User.generateFingerprint();
        // 检查token版本
        this.checkTokenVersion();
    },
    mounted: function () {
        // 多语言
        if (User.isLogin()) {
            this.$store.dispatch("getProfile").then((res) => {
                if (res.lang && User.getLocale() !== res.lang) {
                    User.setLocale(res.lang);
                    location.reload();
                } else if (!res.lang && User.getLocale() !== "en-US") {
                    User.setLocale("en-US");
                    location.reload();
                }
            });
        } else {
            const lang = navigator.language || navigator.userLanguage;
            if (lang && User.getLocale() !== lang) {
                User.setLocale(lang);
                this.setLang(lang);
            }
        }
    },
};
</script>

<style lang="less">
@import "@/assets/css/app.less";
</style>
